<template>
  <div>
    <div class="path">
      <span class="normal pointer" @click="toEcology()">生态服务</span>
      <span class="normal space">/</span>
      <span class="normal pointer" @click="toList()">结算列表</span>
      <span class="normal space">/</span>
      <span class="active">结算编辑</span>
    </div>
    <div class="page">
      <div class="title">
        <h2>结算</h2>
        <div>
          <el-button size="small" @click="onSave()" :loading="loading"
            >保存</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="onSave(true)"
            :loading="loading"
            >保存并提交</el-button
          >
        </div>
      </div>
      <div>
        <h3>申请信息</h3>
        <el-form
          :model="dataForm"
          :rules="dataRule"
          ref="form"
          label-width="120px"
        >
          <el-form-item class="w-half" label="项目名称：" prop="projectName">
            <div @click="onShowProject">
              <el-input
                readonly
                class="form-width"
                v-model="dataForm.projectName"
                placeholder="请选择"
              >
                <div slot="suffix" class="searchIcon">
                  <i class="el-icon-search"></i>
                </div>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item class="w-half" label="申请单号：" prop="demandTableNo">
            <el-input
              readonly
              class="form-width"
              v-model="dataForm.demandTableNo"
              placeholder="不可编辑,通过项目带入"
            ></el-input>
          </el-form-item>
          <el-form-item class="w-half" label="项目经理：" prop="projectManager">
            <el-input
              readonly
              class="form-width"
              v-model="dataForm.projectManager"
              placeholder="不可编辑,通过项目带入"
            ></el-input>
          </el-form-item>
          <h3>
            报工明细<el-button
              class="ml-40"
              type="primary"
              size="small"
              @click="onAddReport"
              >新增</el-button
            >
          </h3>
          <div>
            <Table
              ref="reportTable"
              class="table"
              :tableConfig="reportTableConfig"
            >
              <template :slot="'operation'" slot-scope="scope">
                <el-link type="danger" @click="onRemoveReport(scope)"
                  >删除</el-link
                >
              </template>
            </Table>
          </div>
          <h3>
            交通费明细<el-button
              class="ml-40"
              type="primary"
              size="small"
              @click="onAddCost"
              >新增</el-button
            >
          </h3>
          <div>
            <Table ref="costTable" class="table" :tableConfig="costTableConfig">
              <template :slot="'transportationExpenses'" slot-scope="scope">
                <el-input-number
                  v-model="scope.row.transportationExpenses"
                  :precision="2"
                  :max="999999999.99"
                ></el-input-number>
              </template>
              <template :slot="'transportationFoList'" slot-scope="scope">
                <div>
                  <div
                    v-for="item in devideList[scope.index]
                      .transportationFoList || []"
                    :key="item.aliOssId || item.ossId"
                  >
                    <a class="mr-8" :href="item.url" target="_blank">{{
                      item.fileName
                    }}</a>
                  </div>
                  <div>
                    <el-link type="primary" @click="onAddTableFile(scope.index)"
                      >上传</el-link
                    >
                  </div>
                </div>
              </template>
              <template :slot="'operation'" slot-scope="scope">
                <el-link type="danger" @click="onRemoveCost(scope)"
                  >删除</el-link
                >
              </template>
            </Table>
            <Upload
              ref="tableUpload"
              @success="addTableFile"
              style="display: none"
            />
          </div>

          <h3>节点/验收报告</h3>
          <el-form-item label="附件：" prop="acceptanceFileList">
            <Upload ref="upload" @success="addFile" />
            <div
              v-for="(item, index) in dataForm.acceptanceFileList"
              :key="item.aliOssId"
            >
              <el-tag class="fileTag" closable @close="onRemoveFile(index)">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </el-tag>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <SelectProject
        ref="selectProject"
        @confirm="setProjectHandle"
      ></SelectProject>
      <SelectReport
        ref="selectReport"
        :tableNo="dataForm.demandTableNo"
        @confirm="setReportHandle"
      ></SelectReport>
      <SelectDevice
        ref="selectDevice"
        @confirm="setDeviceHandle"
      ></SelectDevice>
    </div>
  </div>
</template>

<script>
import Upload from "../component/upload.vue";
import Table from "../component/table.vue";
import SelectProject from "../component/settlementSelectProject.vue";
import SelectReport from "../component/settlementSelectReport.vue";
import SelectDevice from "../component/settlementSelectDevice.vue";
import { reportTableConfig, costTableConfig } from "./help";
import tableTotal from "@/utils/tableTotal";
export default {
  components: {
    Upload,
    Table,
    SelectProject,
    SelectReport,
    SelectDevice,
  },
  data() {
    return {
      id: null,
      dataForm: {
        acceptanceFileList: [],
      },
      dataRule: {},
      reportList: [],
      devideList: [],
      rowIndex: null,
      tableTotal: {
        "工时(小时)": "",
        "工时(人/天)": "",
      },
      tableTotal2: {
        交通费: "money",
      },
      loading: false,
    };
  },
  computed: {
    reportTableConfig() {
      const config = { ...reportTableConfig };
      config.summaryMethod = this.getSummaries; // 统计方法
      config.showSummary = true;
      return config;
    },
    costTableConfig() {
      const config = { ...costTableConfig };
      config.summaryMethod = this.getSummaries2; // 统计方法
      config.showSummary = true;
      return config;
    },
    supplierOrderIdList() {
      return this.reportList.map((item) => item.id);
    },
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.getDataSource();
    }
  },
  methods: {
    getDataSource() {
      this.$http
        .post(
          `/front/oms/omsSsoSupplierSettle/supplierSettleDetailById/${this.id}`
        )
        .then(({ data: res }) => {
          const { code, data } = res;
          if (code === 0) {
            this.$set(this, "dataForm", data);

            console.log(this.dataForm);
            this.setReportHandle(data.itemVoList || []);
            this.setDeviceHandle(
              (data.transportVoList || []).map((i) => {
                return {
                  ...i,
                  transportationFoList: i.transportFile,
                };
              })
            );
          }
        });
    },
    onRemoveReport(res) {
      console.log(res);
      this.reportList.splice(res.index, 1);
      this.$refs.reportTable.setFrontPage(this.reportList);
    },
    setReportHandle(res) {
      // 过滤已有的数据
      const filterRes = res.filter(
        (item) => !this.supplierOrderIdList.includes(item.id)
      );

      this.reportList.push(...filterRes);
      this.$refs.reportTable.setFrontPage(this.reportList);
    },
    onAddReport() {
      if (!this.dataForm.demandTableNo) {
        this.$message.warning("请先选择项目");
        return;
      }
      this.$refs.selectReport.onShow(this.dataForm.projectName);
    },
    onRemoveCost(res) {
      this.devideList.splice(res.index, 1);
      this.$refs.costTable.setFrontPage(this.devideList);
    },
    setDeviceHandle(res) {
      const tablenoList = this.devideList.map((item) => item.id);

      // 过滤已有的数据
      const filterRes = res.filter((item) => !tablenoList.includes(item.id));

      this.devideList.push(...filterRes);
      this.$refs.costTable.setFrontPage(this.devideList);
    },
    onAddCost() {
      if (!this.reportList.length) {
        this.$message.warning("请先选择报工单");
        return;
      }

      this.$refs.selectDevice.onShow(this.supplierOrderIdList);
    },
    setProjectHandle(res) {
      const { tableno, deviceid, devicename, projectmanage, projectname } = res;
      this.dataForm.demandTableNo = tableno;
      this.dataForm.deviceId = deviceid;
      this.dataForm.deviceName = devicename;
      this.dataForm.projectManager = projectmanage;
      // this.dataForm.projectName = projectname;
      this.$set(this.dataForm, "projectName", projectname);
      // 项目变化时 报工和装置清空
      // 报工
      this.reportList = [];
      this.$refs.reportTable.setFrontPage(this.reportList);
      // 装置
      this.devideList = [];
      this.$refs.costTable.setFrontPage(this.devideList);

      this.dataForm.acceptanceFileList = [];
    },
    onShowProject() {
      console.log("展示项目列表");
      this.$refs.selectProject.onShow();
    },
    onSave(submit = false) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("表单验证成功");

          if (
            this.devideList.some((i) => {
              return (
                !(i.transportationFoList || []).length ||
                (i.transportationFoList || []).some((f) => {
                  return !f.url;
                })
              );
            })
          ) {
            this.$message.warning("交通费附件必填");
            return;
          }

          const { acceptanceFileList, ...other } = this.dataForm;
          const param = {
            ...other,
            supplierOrderIdList: this.supplierOrderIdList,
            acceptanceFileList: this.formatFileList(acceptanceFileList || []),
            transportationFoList: (this.devideList || []).map((i) => {
              return {
                transportationId: i.id,
                transportationExpenses: i.transportationExpenses,
                transportFile: this.formatFileList(
                  i.transportationFoList || []
                ),
              };
            }),
            // 是否直接提交
            submit,
          };
          console.log(param);
          this.loading = true;
          this.$http
            .post(`/front/oms/omsSsoSupplierSettle/save`, param)
            .then(({ data: res }) => {
              const { code, data } = res;
              if (code === 0) {
                this.$message.success("提交成功");
                this.$router.push({
                  name: "ecologicalServices-settlement-detail",
                  query: {
                    id: data,
                  },
                });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.log("表单验证失败");
        }
      });
    },
    formatFileList(fileList) {
      return fileList.map((i) => {
        return {
          ossId: i.aliOssId || i.ossId,
          fileSize: i.fileSize,
          fileName: i.fileName,
          url: i.url,
        };
      });
    },
    addFile(file) {
      this.dataForm.acceptanceFileList.push(file);
    },
    onRemoveFile(index) {
      this.dataForm.acceptanceFileList.splice(index, 1);
    },
    addTableFile(file) {
      console.log("addTableFile");

      const { aliOssId, ossId, fileSize, fileName, url } = file;
      const item = this.devideList[this.rowIndex];

      if (!item.transportationFoList) {
        item.transportationFoList = [];
      }
      item.transportationFoList.push({
        ossId: aliOssId || ossId,
        fileSize: fileSize,
        fileName: fileName,
        url: url,
      });

      // this.devideList[this.rowIndex] = item
      this.$set(this.devideList, this.rowIndex, item);
      // this.devideList = [...this.devideList]
      this.$refs.costTable.setFrontPage(this.devideList);
      this.$nextTick(() => {
        this.$refs.costTable.doLayout();
      });
    },
    onAddTableFile(index) {
      this.rowIndex = index;
      this.$refs.tableUpload.$refs.upload.$el.querySelector("input").click();
    },
    getSummaries(param) {
      return tableTotal(param, this.tableTotal);
    },
    getSummaries2(param) {
      return tableTotal(param, this.tableTotal2);
    },
    toEcology() {
      this.$router.push({ name: "ecologicalServices" });
    },
    toList() {
      this.$router.push({ name: "ecologicalServices-settlement-list" });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: #fff;
  padding: 20px;
  min-height: 800px;

  ::v-deep .el-select {
    width: 300px;
  }
}

.path {
  height: 36px;
  line-height: 36px;

  .normal {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    color: #999999;
  }

  .active {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: 600;
    color: #333333;
  }

  .space {
    margin-right: 8px;
    margin-left: 8px;
  }
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

h2 {
  font-family: Alibaba PuHuiTi;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

h3 {
  font-family: Alibaba PuHuiTi;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.mr-20 {
  margin-right: 20px;
}

.el-button--primary {
  background-color: #2a54d1;
  border-color: #2a54d1;
}

.el-button--primary:hover {
  opacity: 0.9;
}

.flex {
  display: flex;
}

.fileTag {
  margin-bottom: 16px;
  color: #2a54d1;
  background-color: #f1f5fb;

  ::v-deep a {
    color: #2a54d1;
  }
}

.ml-40 {
  margin-left: 40px;
}

.w-half {
  width: calc(50% - 10px);
}

.form-width {
  width: 300px;
}

.searchIcon {
  color: #333;
  font-size: 16px;
  padding: 0 8px;
}

.table {
  ::v-deep a {
    text-decoration: none;
  }
}

.mr-8 {
  margin-right: 8px;
}
</style>
